module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "container"
  }, [_c('el-col', {
    staticClass: "header",
    attrs: {
      "span": 24
    }
  }, [_c('el-col', {
    staticClass: "logo",
    class: _vm.collapsed ? 'logo-collapse-width' : 'logo-width',
    attrs: {
      "span": 10
    }
  }, [_c('img', {
    staticStyle: {
      "width": "50px",
      "float": "left",
      "padding-right": "12px",
      "display": "inline",
      "padding-top": "15px"
    },
    attrs: {
      "src": require("img/logo.svg")
    }
  }), _c('img', {
    staticStyle: {
      "width": "120px",
      "float": "left",
      "padding-left": "6px",
      "display": "inline",
      "padding-top": "18px"
    },
    attrs: {
      "src": require("img/index_system_name.png")
    }
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('div', {
    staticClass: "tools",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.collapse($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  })])]), _vm._v(" "), _c('el-col', {
    staticClass: "userinfo",
    attrs: {
      "span": 4
    }
  }, [_c('el-dropdown', {
    attrs: {
      "trigger": "hover"
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link userinfo-inner"
  }, [_c('img', {
    attrs: {
      "src": require("img/avatar-128-128.png")
    }
  }), _vm._v(" " + _vm._s(_vm.sysUserName))]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.changePsw($event)
      }
    }
  }, [_vm._v("修改密码")]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "disabled": _vm.userRoleIdentity == 'level-untrue'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.contactAdmin($event)
      }
    }
  }, [_vm._v("联系管理员")]), _vm._v(" "), _c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.getHelpDocument($event)
      }
    }
  }, [_vm._v("帮助文档")]), _vm._v(" "), _c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.logout($event)
      }
    }
  }, [_vm._v("退出登录")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "main",
    attrs: {
      "span": 24
    }
  }, [_c('aside', {
    class: _vm.collapsed ? 'menu-collapsed' : 'menu-expanded'
  }, [_c('el-menu', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.collapsed),
      expression: "!collapsed"
    }],
    staticClass: "el-menu-vertical",
    attrs: {
      "default-active": _vm.$route.path,
      "id": "lastclass",
      "unique-opened": "",
      "router": ""
    },
    on: {
      "open": _vm.handleopen,
      "close": _vm.handleclose,
      "select": _vm.handleselect
    }
  }, [_vm._l((_vm.$router.options.routes), function(item, index) {
    return (!item.hidden) ? [(!item.leaf) ? _c('el-submenu', {
      attrs: {
        "index": index + ''
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      class: item.iconCls
    }), _vm._v(_vm._s(item.name) + "\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t")]), _vm._v(" "), _vm._l((item.children), function(child) {
      return (!child.hidden) ? _c('el-menu-item', {
        key: child.path,
        attrs: {
          "index": child.path
        }
      }, [_vm._v(_vm._s(child.name) + "\n\t\t\t\t\t\t\t")]) : _vm._e()
    })], 2) : _vm._e(), _vm._v(" "), (item.leaf && item.children.length > 0) ? _c('el-menu-item', {
      attrs: {
        "index": item.children[0].path
      }
    }, [_c('i', {
      class: item.iconCls
    }), _vm._v(_vm._s(item.children[0].name) + "\n\t\t\t\t\t\t    "), _c('tipnotes', {
      attrs: {
        "redval": _vm.redMsgCount
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(redtemp) {
          return [_c('i', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (redtemp.text < 100 && redtemp.text > 0),
              expression: "redtemp.text<100 && redtemp.text>0"
            }],
            staticClass: "redtip bg-danger"
          }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(redtemp.text) + "\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('i', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (redtemp.text >= 100),
              expression: "redtemp.text >=100 "
            }],
            staticClass: "redtip bg-danger"
          }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t99+\n\t\t\t\t\t\t\t\t\t\t")])]
        }
      }])
    })], 1) : _vm._e()] : _vm._e()
  })], 2), _vm._v(" "), _c('ul', {
    ref: "menuCollapsed",
    staticClass: "el-menu el-menu-vertical collapsed"
  }, _vm._l((_vm.$router.options.routes), function(item, index) {
    return (!item.hidden) ? _c('li', {
      staticClass: "el-submenu item"
    }, [(!item.leaf) ? [_c('div', {
      staticClass: "el-submenu__title",
      staticStyle: {
        "padding-left": "20px"
      },
      on: {
        "mouseover": function($event) {
          _vm.showMenu(index, true)
        },
        "mouseout": function($event) {
          _vm.showMenu(index, false)
        }
      }
    }, [_c('i', {
      class: item.iconCls
    })]), _vm._v(" "), _c('ul', {
      staticClass: "el-menu submenu",
      class: 'submenu-hook-' + index,
      on: {
        "mouseover": function($event) {
          _vm.showMenu(index, true)
        },
        "mouseout": function($event) {
          _vm.showMenu(index, false)
        }
      }
    }, _vm._l((item.children), function(child) {
      return (!child.hidden) ? _c('li', {
        key: child.path,
        staticClass: "el-menu-item",
        class: _vm.$route.path == child.path ? 'is-active' : '',
        staticStyle: {
          "padding-left": "40px"
        },
        on: {
          "click": function($event) {
            _vm.$router.push(child.path)
          }
        }
      }, [_vm._v(_vm._s(child.name))]) : _vm._e()
    }))] : [_c('li', {
      staticClass: "el-submenu"
    }, [_c('div', {
      staticClass: "el-submenu__title el-menu-item",
      class: _vm.$route.path == item.children[0].path ? 'is-active' : '',
      staticStyle: {
        "padding-left": "20px",
        "height": "56px",
        "line-height": "56px",
        "padding": "0 20px"
      },
      on: {
        "click": function($event) {
          _vm.$router.push(item.children[0].path)
        }
      }
    }, [_c('i', {
      class: item.iconCls
    })])])]], 2) : _vm._e()
  }))], 1), _vm._v(" "), _c('section', {
    staticClass: "content-container"
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light"
  }, [_c('el-col', {
    staticClass: "breadcrumb-container",
    attrs: {
      "span": 24
    }
  }, [_c('el-breadcrumb', {
    staticClass: "breadcrumb-inner",
    attrs: {
      "separator": "/"
    }
  }, _vm._l((_vm.$route.matched), function(item) {
    return _c('el-breadcrumb-item', {
      key: item.path
    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(item.name) + "\n\t\t\t\t\t\t\t")])
  }))], 1), _vm._v(" "), _c('el-col', {
    staticClass: "content-wrapper",
    attrs: {
      "span": 24
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)], 1)])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "修改密码"
    },
    on: {
      "close": _vm.cancelChangePswFormAddSubmit
    },
    model: {
      value: (_vm.changePswDialogVisible),
      callback: function($$v) {
        _vm.changePswDialogVisible = $$v
      },
      expression: "changePswDialogVisible"
    }
  }, [_c('el-form', {
    ref: "changePswForm",
    attrs: {
      "model": _vm.changePswForm,
      "rules": _vm.changePswFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "旧密码",
      "prop": "oldPass",
      "label-width": "100px"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.changePswForm.oldPass),
      callback: function($$v) {
        _vm.$set(_vm.changePswForm, "oldPass", $$v)
      },
      expression: "changePswForm.oldPass"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "新密码",
      "prop": "newPass",
      "label-width": "100px"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.changePswForm.newPass),
      callback: function($$v) {
        _vm.$set(_vm.changePswForm, "newPass", $$v)
      },
      expression: "changePswForm.newPass"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "确认新密码",
      "prop": "newPassConfirm",
      "label-width": "100px"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.changePswForm.newPassConfirm),
      callback: function($$v) {
        _vm.$set(_vm.changePswForm, "newPassConfirm", $$v)
      },
      expression: "changePswForm.newPassConfirm"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.cancelChangePswFormAddSubmit
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.changePswFormOnSubmit
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "联系管理员"
    },
    on: {
      "close": _vm.cancelContactFormAddSubmit
    },
    model: {
      value: (_vm.contactDialogVisible),
      callback: function($$v) {
        _vm.contactDialogVisible = $$v
      },
      expression: "contactDialogVisible"
    }
  }, [_c('el-form', {
    ref: "contactForm",
    attrs: {
      "model": _vm.contactForm,
      "rules": _vm.contactFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "问题标题",
      "prop": "title",
      "label-width": "100px"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.contactForm.title),
      callback: function($$v) {
        _vm.$set(_vm.contactForm, "title", $$v)
      },
      expression: "contactForm.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "问题描述",
      "prop": "content",
      "label-width": "100px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "font-size": "14px"
    },
    attrs: {
      "auto-complete": "off",
      "type": "textarea",
      "rows": 3
    },
    model: {
      value: (_vm.contactForm.content),
      callback: function($$v) {
        _vm.$set(_vm.contactForm, "content", $$v)
      },
      expression: "contactForm.content"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.cancelContactFormAddSubmit
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": _vm.addSubmitButtonDisabled,
      "type": "primary"
    },
    on: {
      "click": _vm.contactFormOnSubmit
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "帮助文档"
    },
    on: {
      "close": _vm.cancelGetHelpDocFormSubmit
    },
    model: {
      value: (_vm.getHelpDocDialogVisible),
      callback: function($$v) {
        _vm.getHelpDocDialogVisible = $$v
      },
      expression: "getHelpDocDialogVisible"
    }
  }, [_c('el-form', {
    ref: "getHelpDocForm",
    attrs: {
      "model": _vm.getHelpDocForm,
      "rules": _vm.getHelpDocFormRules
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-top": "15px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('div', [_c('img', {
    staticStyle: {
      "width": "140px",
      "display": "inline",
      "padding": "60px",
      "padding-bottom": "30px"
    },
    attrs: {
      "src": require("img/help_pdf.png")
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "150px",
      "display": "inline",
      "padding": "60px",
      "padding-bottom": "30px"
    },
    attrs: {
      "src": require("img/help_chm.png")
    }
  })])]), _vm._v(" "), _c('el-radio-group', {
    model: {
      value: (_vm.getHelpDocForm.type),
      callback: function($$v) {
        _vm.$set(_vm.getHelpDocForm, "type", $$v)
      },
      expression: "getHelpDocForm.type"
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    staticStyle: {
      "margin-left": "120px"
    },
    attrs: {
      "label": "1"
    }
  }, [_vm._v("pdf")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    staticStyle: {
      "margin-left": "260px"
    },
    attrs: {
      "label": "2"
    }
  }, [_vm._v("chm")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getHelpDocFormOnSubmit
    }
  }, [_vm._v("确认下载")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "密码到期提醒"
    },
    on: {
      "close": _vm.cancelPswOverRemindFormSubmit
    },
    model: {
      value: (_vm.pswOverRemindDialogVisible),
      callback: function($$v) {
        _vm.pswOverRemindDialogVisible = $$v
      },
      expression: "pswOverRemindDialogVisible"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.upComingExpirePw))]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.nextPswOverRemindFormSubmit
    }
  }, [_vm._v("下次再说")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.gotoChangePsw
    }
  }, [_vm._v("立即修改密码")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "项目到期提醒"
    },
    on: {
      "close": _vm.cancelProjectOverRemindFormSubmit
    },
    model: {
      value: (_vm.projectOverRemindDialogVisible),
      callback: function($$v) {
        _vm.projectOverRemindDialogVisible = $$v
      },
      expression: "projectOverRemindDialogVisible"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.upComingExpireProject))]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.cancelProjectOverRemindFormSubmit
    }
  }, [_vm._v("好的")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-179ac436"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Home.vue
// module id = 882
// module chunks = 1